// declare necessary libraries

import store from "../store";
import loglevel from "loglevel/dist/loglevel";
import fileSaver from "file-saver/dist/FileSaver";
var pjson = require("../../package.json");

var header = {type:'info', datetime: new Date(), value: 'Version ' + pjson.version + ' - ' + pjson.buildDate};
var consoleLogLevel = 0;
var consoleLogLimit = 10000;
var collectedLogs = [header];
var started = false;

function addToCollectedLogs(type, params) {
  if (!isEnabled()) return;
  // Any bespoke types will only be output at most verbose level
  var knownType = ['trace', 'debug', 'log', 'info', 'warn', 'error'].indexOf(type) >=0;
  if (knownType == false && consoleLogLevel <5) return;
  if (type =='trace' && consoleLogLevel <5) return;
  if (type =='debug' && consoleLogLevel <4) return;
  if (type =='log' && consoleLogLevel <4) return;
  if (type =='info' && consoleLogLevel <3) return;
  if (type =='warn' && consoleLogLevel <2) return;
  
  var args = Array.from(params);
  // Filter known clutter
  // Vidyo state
  if (["%c next state", "%c prev state"].includes(args[0])) return;
  // Vidyo color
  if (args.length>0 && ("" + args[1]).includes("color:")) return;
  
  if (collectedLogs.length >= consoleLogLimit)
    collectedLogs.shift();
  collectedLogs.push({type:type, datetime: new Date(), value: args});
}
  
// read waiting/expiry pages
function readConfig() {
  console.debug("ConsoleLogService.readConfig, re-entry=" + started);
  if (started == true) return;
  started = true;
  consoleLogLevel = store.getters.widgetData.config.consoleLogLevel;
  consoleLogLimit = store.getters.widgetData.config.consoleLogLimit;    
  if (consoleLogLevel > 0) {
    console.info('Enabling ConsoleLogService');
    const defaultTrace = console.trace;
    const defaultDebug = console.debug;
    const defaultLog = console.log;
    const defaultInfo = console.info;
    const defaultWarn = console.warn;
    const defaultError = console.error;
  
    console.trace = function(text){
      if (consoleLogLevel>4) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("trace", params);
      }
      defaultTrace.apply(console, arguments);
    };
    console.debug = function(text){
      if (consoleLogLevel>3) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("debug", params);
      }
      defaultDebug.apply(console, arguments);
    };
    console.log = function(text){
      if (consoleLogLevel>3) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("log", params);
      }
      defaultLog.apply(console, arguments);
    };
    console.info = function(text){
      if (consoleLogLevel>2) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("info", params);
      }
      defaultInfo.apply(console, arguments);
    };
    console.warn = function(text){
      if (consoleLogLevel>1) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("warn", params);
      }
      defaultWarn.apply(console, arguments);
    };
    console.error = function(text){
      if (consoleLogLevel>0) {
        let params = arguments;
        if (!params || params.length==0) params = [text];
        addToCollectedLogs("error", params);
      }
      defaultError.apply(console, arguments);
    };
  }
}  

function createLogs() {   
  console.info("Generating logs...");
  setTimeout(() => {
  if (!isEnabled() || !collectedLogs || collectedLogs.length<1) {
    console.info("No logs collected");
    return;
  }
  var logs = collectedLogs;
  // Create new reference now so we don't lose any or corrupt existing
  collectedLogs = [header];
  let content = logs
    .map((i) => {			  
      if (i && i.value) 
      {
        let v = i.value;
        try {
          if (Array.isArray(i.value)) {
            v = '';
            i.value.forEach((value) => {
              if (typeof value === "object") value = JSON.stringify(v);
              if (value && value !== '') {
                if (v !== '') v += '\n';
                v += value;
              }
            });
          }
          else if (typeof v === "object") v = JSON.stringify(v);
        } catch (e) {
          console.error(i);
        }
        return `${i.datetime.toLocaleString()} | ${i.type.toUpperCase()} | ${v}\n`;
      }
    });
  let blob = new Blob(content, { type: "text/plain;charset=utf-8" });
  saveAs(blob, `chatclient(${new Date().toLocaleString()}).log`);						
  }, 1000);
}

function isEnabled() {
  return consoleLogLevel && (consoleLogLevel>0);
}

let ConsoleLogService = {
  readConfig,
  createLogs,
  isEnabled,
  addToCollectedLogs
};
export default ConsoleLogService;
